"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_mail_feature_flags_1 = require("owa-mail-feature-flags");
var maxSuggestionCounts = {
    people: 4,
    folder: 3,
    search: 0,
    category: 1,
};
var maxSuggestionCountsWithFavoriteSearch = {
    people: 3,
    folder: 2,
    search: 2,
    category: 1,
};
function getMaxFavoriteSuggestionCounts() {
    return owa_mail_feature_flags_1.isMailFeatureEnabled('tri-favoriteSearch')
        ? maxSuggestionCountsWithFavoriteSearch
        : maxSuggestionCounts;
}
exports.default = getMaxFavoriteSuggestionCounts;
//# sourceMappingURL=getMaxFavoriteSuggestionCounts.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-find-favorites/lib/actions/helpers/getMaxFavoriteSuggestionCounts.js
// module id = 3209
// module chunks = 68